import { render, staticRenderFns } from "./SidebarRider.vue?vue&type=template&id=d2fb474c&scoped=true"
import script from "./SidebarRider.vue?vue&type=script&lang=js"
export * from "./SidebarRider.vue?vue&type=script&lang=js"
import style0 from "./SidebarRider.vue?vue&type=style&index=0&id=d2fb474c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fb474c",
  null
  
)

export default component.exports